
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './informacion7jb4a.scss';






const Pinformacion7jb4a = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id6898ec9f8e5aed52dc7b540a" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu link-activo "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i91k2"
          href="https://hackathon.sustentahonduras.org/"
        >
          
    <div id="ihnfz" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>Acerca de</>
      <br className="" id="" />
      <>Jóvenes al Voto</>
      </div>
      
      <div className="" id="i9tfg">
        <>Somos un movimiento ciudadano comprometido con empoderar a la nueva generación de votantes. Nuestro propósito es brindar información clara, imparcial y accesible sobre el proceso electoral, para que cada joven pueda ejercer su derecho al voto de manera informada y responsable.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="it9wf" className="">
      
      <img
        className=""
        id="idl0f"
        src="https://assetsprojects.s3.amazonaws.com/404pziime61ygbe.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i7i7cz" className="">
      
      <img
        className=""
        id="i1wqjt"
        src="https://assetsprojects.s3.amazonaws.com/404pziime6223o1.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ib24np" className="">
      
      <div id="iictwd" className="">
      
      <div className="" id="ies3zr">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="ioav37">
        <>somos un equipo de jóvenes apasionados por la democracia y el cambio social. Nacimos con la misión de inspirar y guiar a la nueva generación de votantes, brindando información clara y herramientas prácticas para que participar en las elecciones sea fácil y accesible.</>
      <br className="" id="" />
      <>Creemos que cada voto cuenta y que los jóvenes tienen el poder de transformar el futuro. Por eso trabajamos para derribar mitos, resolver dudas y motivar a que más personas de nuestra generación ejerzan su derecho a decidir.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ib7vm" className="">
      
      <div className="" id="ifhej">
        <>Nuestro Equipo</>
      </div>
      
      <div id="i2r5z" className="">
      
      <img
        className=""
        id="idptr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62bfk4.png"
        alt="undefined"
      />
      
      <div id="ii5r3" className="">
      
      <div
        id="izcvk"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="ik3bo" className="">
      
      <div id="i0dot" className="">
      
      <img
        className="img-tarjeta-alianza "
        id="iyh5u"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfr9r8fi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i7znk" className="">
      
      <div className="" id="iuqiz">
        <>Jesús Jafet Reyes Hernández</>
      </div>
      
      </div>
      
      </div>
      
      <div
        id="iauj8u"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="i5pp1g" className="">
      
      <div id="io2txi" className="">
      
      <img
        className="img-tarjeta-alianza "
        id="inqqpi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfr9r8fi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i2d34m" className="">
      
      <div className="" id="iet7uw">
        <>Camila Victoria Gallardo Linares</>
      </div>
      
      </div>
      
      </div>
      
      <div
        id="ie8eg2"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="iz9hh8" className="">
      
      <div id="ipi04" className="">
      
      <img
        className="img-tarjeta-alianza "
        id="i6pzg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfr9r8fi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="iquxu3" className="">
      
      <div className="" id="i1sxro">
        <>Jezer Adonay Nuñez Rubio</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7g2ak" className="">
      
      <div
        id="ifwc2y"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="iwg84k" className="">
      
      <div id="irl9k4" className="">
      
      <img
        className="img-tarjeta-alianza "
        id="ihero1"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfr9r8fi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="iwusil" className="">
      
      <div className="" id="iram6h">
        <>Héctor Samir Betancourth Lara</>
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i4hypp"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="i2hjdj" className="">
      
      <div id="ieslyj" className="">
      
      <img
        className="img-tarjeta-alianza "
        id="i7pxh2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfr9r8fi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="igjs4d" className="">
      
      <div className="" id="iacw49">
        <>Lia Marcela Cruz</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="ifyeo"
        src="https://assetsprojects.s3.amazonaws.com/404pziime62d1ag.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinformacion7jb4a);
  